import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import imageSrc from '../../assets/launch_timelapse.jpg';
import { BgImage } from '../../components/BgImage/BgImage.styled';
import { InnerSection, Wrapper } from './Next.styled';
import Timer from '../../components/Timer/Timer';
import SectionDetails from '../../components/SectionDetails/SectionDetails';
import MainContainer from '../../components/MainContainer/MainContainer';
import Error from '../../components/Error/Error';
import { fetchNextLaunch } from '../../features/nextSlice';
import { Helmet } from 'react-helmet-async';

const Next = () => {
  const fetchStatus = useSelector((state) => state.nextLaunch.status);
  const { data } = useSelector((state) => state.nextLaunch);

  const hasLaunched = data ? Date.now() > data.date_unix : false;

  const dispatch = useDispatch();

  useEffect(() => {
    if (fetchStatus === 'idle') {
      dispatch(fetchNextLaunch());
    }
  }, [fetchStatus, dispatch]);

  return (
    <>
      <Helmet>
        <link rel='preload' as='image' href={imageSrc} />
      </Helmet>
      {fetchStatus === 'error' && <Error />}
      {data && (
        <MainContainer>
          <BgImage imgSrc={imageSrc} />
          <Wrapper>
            <InnerSection>
              {hasLaunched ? (
                <h2>Launched</h2>
              ) : (
                <Timer date={data.date_local} />
              )}
              <div>
                <h3>next launch</h3>
                <h2>{data.name} mission</h2>
                <SectionDetails data={data.details} initState={false} />
              </div>
            </InnerSection>
          </Wrapper>
        </MainContainer>
      )}
    </>
  );
};

export default Next;
